import { Box, type BoxProps, Flex, Stack, Text } from '@chakra-ui/react'
import { forwardRef, type ReactElement } from 'react'

import { withErrorBoundary } from '@/components/Worlds/UI/ErrorBoundary'

import RichTextEditorBase from './internal/RichTextEditorBase'
import {
  BoldButton,
  BulletedListButton,
  CenterAlignButton,
  Heading2Button,
  Heading3Button,
  HeadingButton,
  ImageButton,
  ItalicButton,
  LeftAlignButton,
  LinkButton,
  MathButton,
  NumberedListButton,
  RightAlignButton,
  UnderlineButton,
} from './internal/ToolbarButtons'
import type { RichTextEditorProps } from './internal/types'
import type { RichTextEditorRef } from './types'

function Toolbar(): React.ReactElement {
  return (
    <Stack direction="row" align="center">
      <BoldButton />
      <ItalicButton />
      <UnderlineButton />
      <HeadingButton />
      <Heading2Button />
      <Heading3Button />
      <LinkButton />
      <MathButton />
      <ImageButton />
      <NumberedListButton />
      <BulletedListButton />
      <LeftAlignButton />
      <CenterAlignButton />
      <RightAlignButton />
    </Stack>
  )
}

const RichTextEditorAdvancedInternal = forwardRef<
  RichTextEditorRef,
  RichTextEditorProps & {
    containerProps?: BoxProps
  }
>(
  ({ containerProps = {}, ...props }, ref): ReactElement => (
    <Box borderRadius="8px" border="1px solid" borderColor="border" bg="bg" {...containerProps}>
      <RichTextEditorBase
        ref={ref}
        {...props}
        header={() => (
          <Flex direction="row" align="center" px="8px" py="8px">
            <Toolbar />
          </Flex>
        )}
        style={{
          maxHeight: '200px',
          overflowY: 'scroll',
          padding: '16px',
          backgroundColor: props.disabled === true ? 'bg.subtle' : 'bg',
          borderRadius: '8px',
        }}
      />
    </Box>
  )
)

const RichTextEditorAdvanced = withErrorBoundary(RichTextEditorAdvancedInternal, () => (
  <Text>Oops! You cannot edit this content right now.</Text>
))

export default RichTextEditorAdvanced
